var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 12.7",
    style: {
      enableBackground: "new 0 0 19 12.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:props.fill;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,5.6H2.8l4.8-4C7.9,1.4,8,0.9,7.7,0.6C7.5,0.3,7,0.2,6.7,0.5L0.3,5.8c0,0,0,0,0,0C0.2,5.9,0.2,5.9,0.1,6 c0,0,0,0.1-0.1,0.1C0,6.1,0,6.2,0,6.3c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0.1,0,0.2,0.1,0.3c0,0,0,0,0,0.1c0,0.1,0.1,0.1,0.1,0.2 c0,0,0,0,0,0l6.4,5.3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.3c0.3-0.3,0.2-0.8-0.1-1.1l-4.8-4h15.4c0.4,0,0.8-0.3,0.8-0.8 S18.7,5.6,18.3,5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBack);
export default __webpack_public_path__ + "static/media/icn_back.fe2e6e8e.svg";
export { ForwardRef as ReactComponent };